import actions from './actions';

const {
	
	CREATE_BEGIN,
	CREATE_SUCCESS,
	CREATE_ERR,

	FETCH_DETAIL_BEGIN,
	FETCH_DETAIL_SUCCESS,
	FETCH_DETAIL_ERR,

	FETCH_LIST_BEGIN,
	FETCH_LIST_SUCCESS,
	FETCH_LIST_ERR,

	FETCH_PROCESS_BEGIN,
	FETCH_PROCESS_SUCCESS,
	FETCH_PROCESS_ERR,

	UPDATE_BEGIN,
	UPDATE_SUCCESS,
	UPDATE_ERR,

	RECEIVE_BEGIN,
	RECEIVE_SUCCESS,
	RECEIVE_ERR,

	CANCEL_BEGIN,
	CANCEL_SUCCESS,
	CANCEL_ERR,

} = actions;

const initialStateFilter = {
	data: null,
	loading: false,
	error: null,
	detail: null,
	list: null,
	process: null,
};

const shipmentReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {

		case CREATE_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
			};
		case CREATE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case CREATE_ERR:
			return {
				...state,
				loading: false,
				error: err,
			};

		case FETCH_DETAIL_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
				detail: null,
			};
		case FETCH_DETAIL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				detail: data,
			};
		case FETCH_DETAIL_ERR:
			return {
				...state,
				loading: false,
				error: err,
				detail: null,
			};

		case FETCH_LIST_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
				list: null,
			};
		case FETCH_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				list: data,
			};
		case FETCH_LIST_ERR:
			return {
				...state,
				loading: false,
				error: err,
				list: null,
			};

		case FETCH_PROCESS_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
				process: null,
			};
		case FETCH_PROCESS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				process: data,
			};
		case FETCH_PROCESS_ERR:
			return {
				...state,
				loading: false,
				error: err,
				process: null,
			};

		case UPDATE_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
			};
		case UPDATE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case UPDATE_ERR:
			return {
				...state,
				loading: false,
				error: err,
			};
		case RECEIVE_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
			};
		case RECEIVE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case RECEIVE_ERR:
			return {
				...state,
				loading: false,
				error: err,
			};

		case CANCEL_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
			};
		case CANCEL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case CANCEL_ERR:
			return {
				...state,
				loading: false,
				error: err,
			};

		default:
			return state;
	}
};

export default shipmentReducer;
